// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './zh';
import en from './en';

// Helpers to persist language selection across refresh
const supported = ['zh', 'en'];
export const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const saved = window.localStorage.getItem('appLang');
    if (saved && supported.includes(saved)) return saved;
  }
  return 'zh';
};

const initialLng = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: ['zh', 'en'],
    supportedLngs: supported,
    debug: false,
    interpolation: { escapeValue: false },
    resources: {
      zh: { translation: zh },
      en: { translation: en },
    },
  });

export const changeAppLanguage = (lng) => {
  const norm = (lng || '').toLowerCase();
  const final = norm.startsWith('zh') ? 'zh' : (supported.includes(norm) ? norm : 'en');
  try { i18n.changeLanguage(final); } catch (_) { /* ignore */ }
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('appLang', final);
  }
};

export default i18n;